export default "__VITE_PUBLIC_ASSET__09d51c38__"